<template>
    <div>
          <div class="form-group">
              <label> Domande </label>
              <select class="form-control" v-model="questionSurveyId">
                <option value="">---</option>

                <option v-for="(questionSurvey) in output_tags" :value="questionSurvey.id">
                  {{ questionSurvey.name }}
                </option>
              </select>
          </div>

        <table>
          <thead>
            <tr>
              <th>Tag</th>
              <th>Label</th>
            </tr>
          </thead>
          <tbody v-if="questionSurveyId !== null">
            <tr v-for="(outputKey,outputTag) in output_tags[questionSurveyId].outputs">
              <td>{{outputTag}}</td>
              <td>{{outputKey}}</td>
            </tr>

          </tbody>
        </table>
    </div>
</template>

<script>

  export default {

    data () {
      return {

        questionSurveyId : null

      }
    },
    methods: {

    },
    mounted() {

    },
    props: {
      output_tags : {
        type : Object,
        required:false,
        default : { }
      }
    }

  }
</script>
